import React from 'react';
import {
  FiTrendingUp,
  FiTrendingDown,
  FiAlertCircle,
  FiStar,
  FiAlertTriangle,
  FiGrid,
} from 'react-icons/fi';
import { InfoTooltip } from '@/components/InfoTooltip';
import styles from '../DashboardOverviewNew.module.scss';

const INSIGHTS_TOOLTIP = {
  description:
    "Automatically generated observations about notable patterns in the team's data spikes, drops, or trends worth a closer look.",
};

const ICON_MAP = {
  'trending-up': FiTrendingUp,
  'trending-down': FiTrendingDown,
  alert: FiAlertCircle,
  star: FiStar,
  warning: FiAlertTriangle,
  app: FiGrid,
};

export const AIInsights = ({ data, isLoading = false }) => (
  <div
    className={styles.quarterCard}
    style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
  >
    <div className={styles.cardHeader}>
      <div className={styles.cardTitleGroup}>
        <span className={styles.cardTitle}>Insights</span>
        <InfoTooltip title="Insights" {...INSIGHTS_TOOLTIP} />
      </div>
    </div>

    <div className={styles.insightsList}>
      {!data?.length && (
        <span
          style={{ fontSize: 13, color: 'var(--gray-400)', padding: '8px 0' }}
        >
          No insights available yet.
        </span>
      )}
      {(data || []).map((item) => {
        const Icon = ICON_MAP[item.iconType] || FiAlertCircle;
        return (
          <div key={item.id} className={styles.insightItem}>
            <div
              className={styles.insightIconWrapper}
              style={{ backgroundColor: item.iconBg }}
            >
              <Icon size={15} color={item.iconColor} />
            </div>
            <div className={styles.insightContent}>
              <span className={styles.insightTitle}>{item.title}</span>
              <span className={styles.insightDesc}>{item.desc}</span>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
